import React, { useState, useEffect } from "react";
import "../styles/feedback.css";

function Feedback() {
  const [type, setType] = useState("");
  const [loading, setLoading] = useState(false);
  const [feedbackList, setFeedbackList] = useState([]);
  const [fetchLoading, setFetchLoading] = useState(true);

  const BASE_URL =
    window.location.hostname === "localhost"
      ? "http://localhost:5000"
      : process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

  const [formData, setFormData] = useState({
    name: "",
    college: "",
    duration: "",
    company: "",
    designation: "",
    experienceYears: "",
    feedback: "",
    rating: "",
  });

  // Fetch all feedback on mount
  useEffect(() => {
    const fetchFeedback = async () => {
      try {
        const res = await fetch(`${BASE_URL}/api/feedback`);
        if (res.ok) {
          const data = await res.json();
          setFeedbackList(data);
        }
      } catch (err) {
        console.error("Error fetching feedback:", err);
      } finally {
        setFetchLoading(false);
      }
    };
    fetchFeedback();
  }, [BASE_URL]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!type) {
      alert("Please select feedback type");
      return;
    }

    try {
      setLoading(true);

      const response = await fetch(`${BASE_URL}/api/feedback`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ type, ...formData }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Submission failed");
      }

      alert("Feedback Submitted Successfully!");

      setFormData({
        name: "",
        college: "",
        duration: "",
        company: "",
        designation: "",
        experienceYears: "",
        feedback: "",
        rating: "",
      });
      setType("");

      // Refresh list after successful submission
      const res = await fetch(`${BASE_URL}/api/feedback`);
      if (res.ok) {
        const freshData = await res.json();
        setFeedbackList(freshData);
      }
    } catch (error) {
      console.error("Feedback Error:", error);
      alert("Error submitting feedback");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="feedback-page">
      <div className="feedback-container">
        <h2>CeiTCS Feedback</h2>
        <h5>Your Valuable Feedback means a Lot to us!</h5>

        {/* ========== DISPLAY SUBMITTED FEEDBACK ========== */}
        <div className="feedback-display-section">
          <h3 className="feedback-display-title">
            {type === "intern"
              ? "Intern Feedback"
              : type === "experienced"
              ? "Employee Feedback"
              : "All Feedback"}
          </h3>

          {fetchLoading ? (
            <p className="feedback-loading">Loading feedback...</p>
          ) : feedbackList.length === 0 ? (
            <p className="feedback-empty">No feedback yet. Be the first to share your experience!</p>
          ) : (
            <div className="feedback-list">
              {feedbackList
                .filter((item) => !type || item.type === type)
                .map((item) => (
                  <div key={item._id} className="feedback-card">
                    <div className="feedback-card-header">
                      <span className="feedback-type-badge">
                        {item.type === "intern" ? "🎓 Intern" : "💼 Employee"}
                      </span>
                      <span className="feedback-rating">
                        {"⭐".repeat(item.rating)}
                      </span>
                    </div>
                    <p className="feedback-author">
                      <strong>{item.name}</strong>
                      {item.type === "intern"
                        ? ` — ${item.college}`
                        : ` — ${item.company}`}
                    </p>
                    {item.type === "intern" && (
                      <p className="feedback-duration">Duration: {item.duration}</p>
                    )}
                    {item.type === "experienced" && (
                      <>
                        <p className="feedback-designation">
                          Designation: {item.designation}
                        </p>
                        <p className="feedback-exp">
                          {item.experienceYears} years of experience
                        </p>
                      </>
                    )}
                    <p className="feedback-msg">"{item.feedback}"</p>
                  </div>
                ))}
            </div>
          )}
        </div>

        {/* ========== SUBMISSION FORM ========== */}
        <div className="selection-buttons">
          <button
            type="button"
            className={type === "intern" ? "active intern-btn" : "intern-btn"}
            onClick={() => setType("intern")}
          >
            Intern Feedback
          </button>

          <button
            type="button"
            className={
              type === "experienced"
                ? "active experienced-btn"
                : "experienced-btn"
            }
            onClick={() => setType("experienced")}
          >
            Employee Feedback
          </button>
        </div>

        {type && (
          <form onSubmit={handleSubmit} className="form-section">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              required
              value={formData.name}
              onChange={handleChange}
            />

            {type === "intern" && (
              <>
                <input
                  type="text"
                  name="college"
                  placeholder="College Name"
                  required
                  value={formData.college}
                  onChange={handleChange}
                />

                <input
                  type="text"
                  name="duration"
                  placeholder="Internship Duration"
                  required
                  value={formData.duration}
                  onChange={handleChange}
                />
              </>
            )}

            {type === "experienced" && (
              <>
                <input
                  type="text"
                  name="company"
                  placeholder="Current Company"
                  required
                  value={formData.company}
                  onChange={handleChange}
                />

                <input
                  type="text"
                  name="designation"
                  placeholder="Designation"
                  required
                  value={formData.designation}
                  onChange={handleChange}
                />

                <input
                  type="number"
                  name="experienceYears"
                  placeholder="Years of Experience"
                  required
                  value={formData.experienceYears}
                  onChange={handleChange}
                />
              </>
            )}

            <textarea
              name="feedback"
              placeholder="Your Feedback about CeiTCS"
              required
              value={formData.feedback}
              onChange={handleChange}
            />

            <select
              name="rating"
              required
              value={formData.rating}
              onChange={handleChange}
            >
              <option value="">Select Rating</option>
              <option value="5">⭐⭐⭐⭐⭐ - Excellent</option>
              <option value="4">⭐⭐⭐⭐ - Very Good</option>
              <option value="3">⭐⭐⭐ - Good</option>
              <option value="2">⭐⭐ - Average</option>
              <option value="1">⭐ - Poor</option>
            </select>

            <button type="submit" disabled={loading}>
              {loading ? "Submitting..." : "Submit Feedback"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default Feedback;
